import * as React from "react";
import classnames from "classnames";
import { Accordion, AccordionItem } from "@grandvisionhq/common";
import AppointmentTypeButtonContainer from "../../../../../../AppointmentTypeButton/v3/components/AppointmentTypeButton/AppointmentTypeButtonContainer.js";
const GroupedAppointmentTypeList = ({
  className,
  groupedAppointmentTypes,
  groupedAppointmentTypeToolTips,
  groupedAppointmentGlobalLabels,
  onClick,
  onClickToolTip
}) => {
  const filteredGroupedVisibleToCustomersAppointmentTypes = groupedAppointmentTypes.map(
    (group) => ({
      ...group,
      appointmentTypes: group.appointmentTypes.filter(
        (appointmentType) => appointmentType.isVisibleToCustomers
      )
    })
  );
  const hasVisibleAppointmentTypes = filteredGroupedVisibleToCustomersAppointmentTypes.some(
    (group) => group.appointmentTypes.length > 0
  );
  if (hasVisibleAppointmentTypes && filteredGroupedVisibleToCustomersAppointmentTypes)
    return /* @__PURE__ */ React.createElement("div", { className: classnames("appointment-type-list__grouped", className) }, /* @__PURE__ */ React.createElement(Accordion, null, filteredGroupedVisibleToCustomersAppointmentTypes.map(
      (appointmentGroup, i) => appointmentGroup.appointmentTypes.length >= 1 && /* @__PURE__ */ React.createElement(
        AccordionItem,
        {
          id: "group-appointment-item",
          key: i,
          className: "appointment-type-list__grouped-item",
          icon: appointmentGroup.icon,
          label: appointmentGroup.title,
          expanded: false
        },
        appointmentGroup.appointmentTypes.map(
          (appointmentTypeInGroup) => appointmentTypeInGroup.isVisibleToCustomers && /* @__PURE__ */ React.createElement(
            AppointmentTypeButtonContainer,
            {
              key: appointmentTypeInGroup.id,
              appointmentType: appointmentTypeInGroup,
              toolTip: groupedAppointmentTypeToolTips[appointmentTypeInGroup.id],
              onClick,
              onClickToolTip,
              "data-t": groupedAppointmentGlobalLabels[appointmentTypeInGroup.id] || appointmentTypeInGroup.id
            }
          )
        )
      )
    )));
  return null;
};
export {
  GroupedAppointmentTypeList as default
};
//# sourceMappingURL=GroupedAppointmentTypeList.js.map
